<template>
  <b-card no-body
          class="mb-1 border-0"
  >
    <b-card-header header-tag="header"
                   class="p-0 border-0"
                   role="tab"
    >
      <b-button block
                variant="primary"
      >
        <i class="fa fa-map-marker"/>
        UBICACIONES
      </b-button>
    </b-card-header>
    <b-card-body class="py-3 px-0">
      <b-row>
        <b-col sm="8">
          <b-form-group>
            <b-input-group>
              <b-form-input name="nombre"
                            type="text"
                            placeholder="Buscar..."
                            v-model="filtro.ubicacion"
                            class="text-uppercase"
                            @keypress.enter="listarUbicaciones"
              />
              <b-input-group-append>
                <b-button variant="primary"
                          @click.prevent="listarUbicaciones"
                >
                  <i class="fa fa-search fa-lg"/>
                  <span class="d-none d-md-inline-block">Buscar</span>
                </b-button>
                <b-button @click="limpiarUbicaciones">
                  <i class="fa fa-eraser fa-lg"/>
                  <span class="d-none d-md-inline-block"> Limpiar</span>
                </b-button>
              </b-input-group-append>
            </b-input-group>

          </b-form-group>
        </b-col>

        <b-col sm="4">
          <b-button variant="primary"
                    class="float-right"
                    @click="verModal"
          >
            Nuevo
          </b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-table responsive
                   striped
                   hover
                   small
                   :items="ubicaciones.data"
                   :fields="columnas"
                   thead-tr-class="table-active"
                   class="mb-2"
          >
            <template v-slot:cell(ubicacion_padre)="data">
              <div v-if="data.item.ubicacion_empresa &&
                          data.item.ubicacion_empresa.get_parent[0] &&
                          data.item.ubicacion_empresa.get_parent[0].get_ubicacion &&
                          data.item.ubicacion_empresa.get_parent[0].get_ubicacion.descripcion"
              >
                {{ data.item.ubicacion_empresa.get_parent[0].get_ubicacion.descripcion }}
              </div>
            </template>


            <template v-slot:cell(estado)="data">
              <b-badge v-if="data.item.activo"
                       variant="primary"
                       v-text="'Activa'"
              />
              <b-badge v-else
                       variant="danger"
                       v-text="'Inactiva'"
              />
            </template>

            <template v-slot:cell(actions)="data">
              <a v-b-tooltip.hover
                 class="botonProduct text-dark mr-3"
                 title="Editar"
                 @click="editarUbicacion(data.item)"
              >
                <i class="fa fa-edit"></i>
              </a>

              <a v-if="data.item.get_nivel.nivel <= 1"
                 v-b-tooltip.hover
                 class="botonProduct text-success mr-3"
                 title="Crear padre"
                 @click="crearPadre(data.item)"
              >
                <i class="fa fa-plus"></i>
              </a>

              <a v-else
                 v-b-tooltip.hover
                 class="botonProduct text-info mr-3"
                 title="Asociar"
                 @click="verModalUbicacion(data.item)"
              >
                <i class="fa fa-link"></i>
              </a>

              <a v-b-tooltip.hover
                 class="botonProduct"
                 :title="!!data.item.activo ? 'Inactivar' : 'Activar'"
                 @click="eliminarUbicacion(data.item)"
              >
                <i class="fa fa-close text-danger"
                   v-if="!!data.item.activo"
                />
                <i class="fa fa-check text-success"
                   v-else
                />
              </a>

            </template>
          </b-table>

          <el-pagination v-if="ubicaciones.data && !!ubicaciones.data.length"
                         v-model="filtro.page"
                         @size-change="buscador(filtro)"
                         @current-change="buscador(filtro)"
                         :current-page.sync="filtro.page"
                         class="float-right"
                         :page-size.sync="filtro.perPage"
                         :page-sizes="[10, 30, 50, 100]"
                         layout="total, sizes, prev, pager, next"
                         :total="ubicaciones.total"
          />
        </b-col>
      </b-row>
    </b-card-body>

    <b-modal v-model="modal_ubicaciones.ver"
             title="Actualizar ubicación"
             hide-footer
    >
      <form @submit.prevent="validarFormularioUbicaciones"
            data-vv-scope="ubicaciones"
      >
        <b-row>
          <b-col sm="12">
            <b-form-group>
              <label for="descripcion">Descripción</label>
              <b-form-input type="text"
                            id="descripcion"
                            name="descripcion"
                            data-vv-as=" "
                            v-validate="'required|min:3|max:100'"
                            v-model="selectedUbicacion.descripcion"
              />
              <span class="text-danger span-error small">{{ errors.first('ubicaciones.descripcion') }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-center">
            <hr>
            <b-button @click="validarFormularioUbicaciones"
                      size="sm"
                      variant="primary"
            >
              <i class="fa fa-floppy-o fa-lg"></i> Guardar
            </b-button>
          </b-col>
        </b-row>
      </form>
    </b-modal>
    <modal-ubicacion/>
  </b-card>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import modalUbicacion from './modal';
import {establecerModalUbicaciones} from '../../../servicios/empresa/ubicaciones/mutations';

export default {
  name: 'ubicaciones',
  components: {
    modalUbicacion
  },
  data() {
    return {
      columnas: [
        {
          key: 'get_nivel.nivel',
          label: 'Nivel',
          sortable: true,
          tdClass: 'text-center',
          thClass: 'text-center',
          thStyle: 'width: 80px; max-width:80px'
        },
        {
          key: 'get_nivel.descripcion',
          label: 'Descripción nivel',
          tdClass: 'text-uppercase',
          sortable: true
        },
        {
          key: 'descripcion',
          label: 'Ubicacion',
          sortable: true
        },
        {
          key: 'ubicacion_padre',
          label: 'Ubicacion padre',
          sortable: true
        },
        {
          key: 'estado',
          label: 'Estado',
          sortable: true,
          tdClass: 'text-center',
          thClass: 'text-center',
          thStyle: 'width: 120px; max-width:120px'
        },
        {
          key: 'actions',
          label: 'Opciones',
          tdClass: 'text-center',
          thClass: 'text-center',
          thStyle: 'width: 120px; max-width:120px'
        },
      ]
    };
  },
  computed: {
    ...mapState('ubicacion', [
      'ubicaciones',
      'selectedUbicacion',
      'filtro',
      'modal_ubicaciones',
      'asociar'
    ]),
  },
  methods: {
    ...mapActions('ubicacion', [
      'listarUbicaciones',
      'listarNivelActivos',
      'updateUbicacion',
      'crearUbicacionEmpresa',
      'arbolUbicacionesEmpresa',
      'verListaUbicaciones',
      'deleteUbicacion'
    ]),
    ...mapMutations('ubicacion', [
      'resetFiltroUbicaciones',
      'establecerAsociar',
      'setModal',
      'resetSelectedUbicacion',
      'establecerModalUbicaciones',
      'setSelectedUbicacion',
      'setIdUbicacion',
      'setIdParent',
      'setEnlazar',
      'setPaso'
    ]),
    async limpiarUbicaciones() {
      this.resetFiltroUbicaciones();
      await this.listarUbicaciones();
    },
    async eliminarUbicacion(ubicacion) {
      this.setSelectedUbicacion(ubicacion);
      await this.deleteUbicacion();
    },
    async verUbicacion(id) {
      this.setFiltro(id);
      this.setFiltroNivel(id);
      await this.listarUbicaciones(this.$route.params.id);
      await this.listarUbicacionesEmpresa(this.$route.params.id);
    },
    async verModal() {
      this.establecerAsociar(false);
      await this.listarNivelActivos();
      this.setModal(true);
    },
    async crearPadre(datos) {
      this.setIdUbicacion(datos.id);
      this.setIdParent(0);
      await this.crearUbicacionEmpresa();
      await this.arbolUbicacionesEmpresa();
    },
    async editarUbicacion(ubicacion) {
      this.setSelectedUbicacion(ubicacion);
      this.establecerModalUbicaciones(true);
    },
    async validarFormularioUbicaciones() {
      await this.$validator.validateAll('ubicaciones')
        .then(async (validado) => {
          if (validado) {
            await this.updateUbicacion();
            this.establecerModalUbicaciones(false);
          }
        });
    },
    async verModalUbicacion(datos) {
      this.establecerAsociar(true);
      this.setEnlazar(datos.get_nivel);
      this.setIdUbicacion(datos.id);
      await this.verListaUbicaciones();
      this.setPaso(1);
      this.setModal(true);
      await this.arbolUbicacionesEmpresa();
    }
  }
};
</script>

<style scoped>

</style>
